import Component from '../core/Component'

export default class BlogCategoryList extends Component {
    constructor(element, options) {
        super(element, options)
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        const element = event.target.closest('.is-active')
        if (!element) {
            return
        }
        
        event.preventDefault()
        this.toggle()
    }

    toggle() {
        this.element.classList.toggle('is-open')
    }
}